import store from '../../../../store';
import { CONTACTS_ACTIONS } from '../../../../store/v1/contacts/contacts.constants';
import { ResourceApi } from 'v5/api/resource/resource.api';
import { WithServices } from 'v5/platform/ts/services';
import { WithErrorService } from 'v5/services/front/ErrorService/ErrorService';
import { SystemEffect } from 'v5/services/internal/MessageService/_private/SystemEffectMessage';
import { WithMessageService } from '../../internal/MessageService/MessageService';
import { ResourceMutationService } from './ResourceMutationService';

export function createResourceMutationService(
  config: WithServices<[WithMessageService, WithErrorService]> & {
    api: ResourceApi;
  }
): ResourceMutationService {
  const {
    api,
    services: { messageService, errorService }
  } = config;
  const interceptor = errorService.withCategory('ResourceMutationService');

  async function reportEffectAndWaitUntilCacheReady(
    scope: SystemEffect[] = []
  ) {
    await messageService.reportSystemEffect.sendRequest(
      {
        scope
      },
      3000
    );
  }
  return {
    updateResource: interceptor.wrap(async request => {
      const result = await api.updateItem(request.id, request.data);

      store.dispatch({
        type: CONTACTS_ACTIONS.UPDATE_CONTACT_SUCCESS,
        result
      });

      await reportEffectAndWaitUntilCacheReady([
        {
          entity: 'resource',
          entityId: request.id,
          payload: { type: 'update' }
        }
      ]);

      return result;
    }),
    transferResourcesToWorkspace: interceptor.wrap(async request => {
      await api.transferResourcesToWorkspace({
        ids: request.ids,
        enterprise_workspace_id: request.enterprise_workspace_id
      });

      const resources = await api.getItems(request.ids);
      for (const resource of resources) {
        store.dispatch({
          type: CONTACTS_ACTIONS.UPDATE_CONTACT_SUCCESS,
          result: resource
        });
      }

      await reportEffectAndWaitUntilCacheReady(
        request.ids.map(id => ({
          entity: 'resource',
          entityId: id,
          payload: { type: 'update' }
        }))
      );
    }),
    archiveResources: interceptor.wrap(async request => {
      try {
        await api.bulkArchive(request);

        // Report system effects for successfully archived resources

        await reportEffectAndWaitUntilCacheReady(
          request.ids.map(id => ({
            entity: 'resource',
            entityId: id,
            payload: { type: 'update' }
          }))
        );
      } catch (error) {
        console.error('Failed to archive resources:', error);
        throw new Error('Failed to archive resources');
      }
    }),

    unarchiveResources: interceptor.wrap(async request => {
      try {
        await api.bulkUnarchive(request);

        // Report system effects for successfully unarchived resources

        await reportEffectAndWaitUntilCacheReady(
          request.ids.map(id => ({
            entity: 'resource',
            entityId: id,
            payload: { type: 'update' }
          }))
        );
      } catch (error) {
        console.error('Failed to unarchive resources:', error);
        throw new Error('Failed to unarchive resources');
      }
    })
  };
}
